/**
 * useAuth hook for the Sales Copilot mobile app.
 *
 * Provides typed access to the CopilotAuthContext.
 * Must be used inside a <CopilotAuthProvider>.
 */

import { useContext } from "react";
import { CopilotAuthContext, type CopilotAuthContextValue } from "../context/AuthContext";

export function useAuth(): CopilotAuthContextValue {
  const ctx = useContext(CopilotAuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used within a <CopilotAuthProvider>");
  }
  return ctx;
}
